module.exports = __webpack_public_path__ + "static/media/s10.19d0da4b.jpg";